<template>
    <div>
        <el-dialog title="提示" :visible.sync="centerDialogVisible" :append-to-body="true" :modal-append-to-body="false"
            :close-on-click-modal="false" width="50%" center>
            <span>请输入短信验证码</span>
            <span slot="footer" class="dialog-footer">
                <div style="display: flex;justify-content: center;margin-top: 20px;">
                    <el-button type="primary" @click="messageSubmit">确认</el-button>

                    <el-button @click="closeDialog">关闭</el-button>

                </div>
            </span>
            <el-form ref="form" label-width="80px" style="overflow-y: auto; margin-top: 20px;">
                <el-form-item label="短信验证码:" label-width='120px'>
                    <el-input v-model="message_data" style="width: 150px; margin-right:5px">
                    </el-input>
                    <el-button type="text" v-if="time==0" @click="cashierPsSmsReNotify">重新发送</el-button>
                    <el-button type="text" disabled v-else>{{time}}s后可重新发送</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    var _this, t;
    export default {
        props: {
            'isShow': Boolean,
            'applyNo': '',
            'busType': '',
            'port': '',
        },
        watch: {

            isShow(newData, oldData) {
                console.log('短信验证码打开');
                console.log(_this.applyNo,'applyNo');
                console.log(_this.busType,'busType');
                console.log(_this.port,'port');
                _this.centerDialogVisible = true;

                _this.post_applyNo = _this.applyNo;
                _this.post_busType = _this.busType;
                _this.post_port = _this.port;

                _this.timeInterval()

            }
        },

        data() {
            return {

                centerDialogVisible: false,

                post_applyNo: '',
                post_busType: '',
                post_port: '',
         

                time: 120,

                // 短信验证码
                message_data: '',

                // 短信验证码验证规则
                message_rules: {
                    placeholder: '短信验证码',
                    rules: {
                        required: true,
                        message: '短信验证码不能为空',
                        regulation: 'elt_str',
                        rulesData: 6
                    }
                },
                


            };
        },

        created() {
            _this = this;

        },
        methods: {

            
            timeInterval() {




                t = setInterval(() => {
                    if (_this.time > 0) {
                        _this.time -= 1;
                    } else {
                        clearInterval(t)
                    }
                }, 1000);
            },


            // 短信确认
            messageSubmit() {

                

                _this.$post(
                    "/easy_cashier/cashierPsSms", {
                    applyNo: _this.post_applyNo,
                    verifyCode: _this.message_data,
                    port: _this.post_port,
                    busType: _this.post_busType
                },
                ).then(res => {

                    _this.$message.success(res.msg);
                    _this.closeDialog();



                }).catch((err) => {

                })


            },
            // 短信重发
            cashierPsSmsReNotify() {

                clearInterval(t);

                _this.time = 120;
                _this.timeInterval();

                _this.$post(
                    "/easy_cashier/cashierPsSmsReNotify", {
                    applyNo: _this.post_applyNo,
                    busType: _this.post_busType,
                    port: _this.post_port
                }
                ).then(res => {




                }).catch((err) => {

                })


            },

          


            // 关闭方法
            closeDialog() {

                _this.message_data = '';
                _this.centerDialogVisible = false;

                _this.time = 120;
                clearInterval(t);
                _this.$emit('messageSucss')
            },
           


        },


    };
</script>